import React from 'react'
import { Route } from 'react-router-dom'
import styled from 'styled-components'

import NADLSideNav from 'app/gears/nadl/components/NADLSideNav'
import NADLRecordMaintenance from 'app/gears/nadl/containers/NADLRecordMaintenance'
import NADLRunReports from 'app/gears/nadl/containers/NADLRunReports'
import LandingPage from 'app/gears/nadl/containers/NADLLandingPage'

/**
 * The root component for the LGY NADL application, formerly hosted in Nashville/Cleveland
 * 
 * @author Robbie Hinojosa
 * 
 * **/

const NADLApp = ({ user }) => {
  const canViewRecords = user.authorizations.includes('View NADL Loan Record')
  const canEditRecords = user.authorizations.includes('Add/Edit NADL Loan Record')
  const canEditDocuments = user.authorizations.includes('Add NADL Loan Document')
  const canViewReports = user.authorizations.includes('View NADL Loan Reports')
  return (<div className='usa-grid'>
    <div className='usa-width-one-sixth'>
      <NADLSideNav canViewRecords={canViewRecords} canViewReports={canViewReports} />
    </div>
    <div className='usa-width-five-sixths'>
      <Route exact path='/lgyhub/NADL/records' render={() => <NADLRecordMaintenance canEditRecords={canEditRecords} canEditDocuments={canEditDocuments} />} />
      <Route exact path='/lgyhub/NADL/reports' component={NADLRunReports} />
      <Route exact path='/lgyhub/NADL/' component={LandingPage} />
    </div>
  </div>)
}

export default styled(NADLApp)`
  padding-top: 2rem;
  margin-bottom: 5rem;
`